<template>
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="500px" transition="dialog-transition">
   <template v-slot:activator="{ on }">
      <v-icon v-on="on" slot="activator" class="mr-2" small>edit</v-icon>
    </template>

    <v-form @submit.prevent="onSupplierUpdate" ref="form" v-model="valid">
          <v-card class="elevation-2">
            <app-alert-error v-if="error" @dismissed="onDismiss" :text="error.message" class="mb-0"></app-alert-error>
            <app-alert-info v-if="info" @dismissInfo="onDismissInfo" :text="info" class="mb-0"></app-alert-info>
            <v-card-title class="primary white--text">
              <v-row class="mx-1">
                <h4>
                  Update supplier
                </h4>
                <v-spacer></v-spacer>
                <v-icon class="font-weight-black white--text" @click="closeDialog">clear</v-icon>
              </v-row>
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>

              <v-container>
                  <v-row row>
                  <template v-if="supplier.type === 'independent'">
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">First Name: </div>
                      <v-text-field name="firstName" id="firstName" type="text" :rules="fieldRules('First Name', 30)" v-model="supplier.firstName" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">Last Name: </div>
                      <v-text-field name="lastName" id="lastName" type="text" :rules="fieldRules('Last Name', 30)" v-model="supplier.lastName" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">Phone Number: </div>
                      <v-text-field name="phoneNumber" id="phoneNumber" type="tel" :rules="fieldRules('Phone Number', 20)" v-model="supplier.phoneNumber" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">E-mail: </div>
                      <v-text-field name="email" id="email" type="email" v-model="supplier.email" dense regular required></v-text-field>
                    </v-flex>
                  </template>
                  <template v-if="supplier.type === 'business'">
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">First Name: </div>
                      <v-text-field name="firstName" id="firstName" type="text" :rules="fieldRules('First Name', 30)" v-model="supplier.firstName" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">Last Name: </div>
                      <v-text-field name="lastName" id="lastName" type="text" :rules="fieldRules('Last Name', 30)" v-model="supplier.lastName" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">Phone Number: </div>
                      <v-text-field name="phoneNumber" id="phoneNumber" type="tel" :rules="fieldRules('Phone Number', 20)" v-model="supplier.phoneNumber" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">E-mail: </div>
                      <v-text-field name="email" id="email" type="email" :rules="fieldRules('E-mail', 50)" v-model="supplier.email" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">Position
                        <ShowInfo infoText="The position in Company of the person who will be managing this account" />
                        :
                      </div>
                      <v-text-field name="position" id="position" type="text" :rules="fieldRules('Position', 50)" v-model="supplier.position" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">Company Name: </div>
                      <v-text-field name="compnay-name" id="compnay-name" type="text" :rules="fieldRules('Company Name', 50)" v-model="supplier.companyName" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">
                      <div class="mr-2">Company Website: </div>
                      <v-text-field name="website" id="website" type="url" :rules="fieldRules('Website', 50)" v-model="supplier.website" dense regular required></v-text-field>
                    </v-flex>
                    <v-flex xs10 offset-xs1 class="d-flex flex-wrap align-center">

                      <div class="mr-2">Registration Number
                        <ShowInfo infoText="Company Registration Number" />
                        :
                      </div>
                      <v-text-field name="reg-nb" id="reg-nb" type="text" :rules="fieldRules('Registration Number', 50)" v-model="supplier.companyRegNb" dense regular required></v-text-field>
                    </v-flex>
                  </template>
                </v-row>

              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="white--text" class="mr-4  px-4 grey darken-1" @click="closeDialog">Cancel</v-btn>
              <v-btn v-if="!isLoading" depressed class="info white--text" type="submit">
                Update supplier
              </v-btn>
              <v-btn v-else loading depressed type="submit">
                Update supplier
              </v-btn>
            </v-card-actions>
          </v-card>
    </v-form>
    <v-snackbar v-model="snackbar" color="farmer_green" :timeout="timeout" dense bottom right>
      {{ snackbarText }}
      <v-spacer></v-spacer>
      <v-icon color="white" @click="snackbar = false">close</v-icon>
    </v-snackbar>
  </v-dialog>
</template>
<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'UpdateSupplier',
  components: { ShowInfo: () => import('@/components/shared/ShowInfo') },
  props: ['supplier', 'id'],
  data() {
    return {
      dialog: false,
      valid: true,
      isLoading: false,
      // type: [this.supplier],
      // supplierTypes: ['independent', 'business'],
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      supplierTypes: ['independent', 'business'],
      // Make a real copy(not reference) of the supplier object
      originalSupplier: Object.assign({}, this.supplier)
    }
  },
  computed: {
    ...mapGetters(['error', 'info']),
    fieldRules() {
      return (fieldName, maxChar) => [
        v => (!!v && !!v.trim()) || `${fieldName} is required`,
        v =>
          (v && v.length <= maxChar) ||
          `${fieldName} must be less than ${maxChar} characters`
      ]
    },
    validType() {
      return [
        v => !!v || 'Type is required',
        v =>
          v === 'independent' ||
          v === 'business' ||
          "Type can only take one of this valus 'independent', 'business'"
      ]
    },
    changed() {
      /**
       * Check if the supplier object has changed
       * trim every string, to avoid saving unnecessary changes
       */
      const supp = Object.values(this.supplier).map(s => {
        if (typeof s === 'string') return s.trim()
        else return s
      })
      const ogSupp = Object.values(this.originalSupplier).map(s => {
        if (typeof s === 'string') return s.trim()
        else return s
      })
      return !(JSON.stringify(supp) === JSON.stringify(ogSupp))
    }
  },
  methods: {
    onDismissInfo() {
      store.commit('clearInfo')
    },
    closeDialog() {
      this.dialog = false
      this.isLoading = false
    },
    onSupplierUpdate() {
      if (!this.changed) {
        store.commit('setInfo', 'Nothing has been changed yet. \n If you didn\'t intend to modify this supplier, please close this window.')
        return
      }

      const updateDetails = { supplier: this.supplier }

      // if phone number has changed, add isNewPhoneNumber field
      if (this.supplier.phoneNumber !== this.originalSupplier.phoneNumber) {
        updateDetails.isNewPhoneNumber = true
      }
      /**
       * Check whether the form is valid
       */
      if (this.$refs.form.validate()) {
        // TODO: update the supplier object
        store.dispatch('updateSupplier', updateDetails)
          .then(() => {
            this.closeDialog()
          })
          .catch(err => {
            store.commit('setError', err)
          })
      }
      // }
    }
  }
}
</script>
